import { API_BASE_URL } from '../../../../../config';
import { DONE_STEP_ID } from './hireHealthSurveySteps';
import type { HireHealthFormValues } from './hireHealthSurveyTypes';

export { DONE_STEP_ID };

export type HireHealthSurveyProgressPayload = {
  values: HireHealthFormValues;
  currentStepId: string | null;
};

export async function fetchHireHealthSurveyProgress(
  email: string
): Promise<HireHealthSurveyProgressPayload | null> {
  if (!API_BASE_URL || !email?.trim()) return null;
  const params = new URLSearchParams({ email: email.trim() });
  const r = await fetch(`${API_BASE_URL}/api/hire-health-survey/progress?${params.toString()}`);
  if (!r.ok) return null;
  const data = (await r.json()) as {
    values?: HireHealthFormValues;
    currentStepId?: string | null;
  };
  return {
    values: data.values && typeof data.values === 'object' ? data.values : {},
    currentStepId: data.currentStepId ?? null,
  };
}

export async function upsertHireHealthSurveyProgress(params: {
  email: string;
  values: HireHealthFormValues;
  currentStepId: string | null;
}): Promise<void> {
  if (!API_BASE_URL || !params.email?.trim()) return;
  try {
    const r = await fetch(`${API_BASE_URL}/api/hire-health-survey/progress`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: params.email.trim(),
        values: params.values,
        currentStepId: params.currentStepId,
      }),
    });
    if (!r.ok) {
      console.warn('Hire health survey save failed', r.status);
    }
  } catch (e) {
    console.warn('Hire health survey save failed', e);
  }
}
